module.exports = __webpack_public_path__ + "static/img/header.963ec60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/welfare/header.png
// module id = yi2l
// module chunks = 1